import { apiBaseQuery } from 'store/api';
import { AUTH0_API_URL } from 'constants';


const baseQuery = () => async (params, { getState }) => {
  const { auth0ApiUrl } = getState().initialize.config;
  return await apiBaseQuery({
    baseURL : auth0ApiUrl,
    ...params,
  });
};

export default baseQuery;
